import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowRightCircle } from "react-bootstrap-icons";

import opalImg from "../assets/img/WebKbanner2.png";
import projImg2 from "../assets/img/Products02.jpg";
import projImg3 from "../assets/img/Products01.jpg";
import projImg4 from "../assets/img/Products04.jpg";
import projImg5 from "../assets/img/Products05.jpg";
import projImg6 from "../assets/img/Products06.jpg";

const ipCores = [
  {
    title: "Daylight Vision IP Core",
    imgUrl: projImg2,
    link: "/products#daylightV",
  },
  {
    title: "HDR IP Core",
    imgUrl: projImg3,
    link: "/products#HDR",
  },
  {
    title: "Image Resize IP Core",
    imgUrl: projImg5,
    link: "/products#IMR",
  },
  {
    title: "Non Uniformity Correction IP Core",
    imgUrl: projImg6,
    link: "/products#NonUni",
  },
  {
    title: "Target Tracking IP Core",
    imgUrl: projImg4,
    link: "/products#TargetTrack",
  },
];

export const Projects = () => {
  return (
    <section
      className="products-showcase"
      id="projects"
      aria-labelledby="products-showcase-title"
    >
      <Container>

        {/* SECTION HEADING */}
        <div className="products-showcase__heading">
          <span className="products-showcase__eyebrow">
            IMAGING PRODUCTS & FPGA IP
          </span>

          <h2 id="products-showcase-title">
            Products engineered around image quality.
          </h2>

          <p>
            Kristal Fotonik offers a wide range of products from
            high-resolution cameras to FPGA-based image processing IP cores.
            Our solutions are tailored for advanced imaging applications in
            machine vision, industrial automation, robotics, and smart cities.
            For more details about our products, please don’t hesitate to
            contact us.
          </p>
        </div>

        {/* FEATURED OPAL PRODUCT */}
        <article className="products-featured">
          <div className="products-featured__content">
            <span className="products-featured__label">
              FEATURED CAMERA
            </span>

            <h3>Opal-1920S Visible Light Camera</h3>

            <p>
              A compact visible-light imaging platform combining advanced
              image processing, flexible video output and a rugged mechanical
              design.
            </p>

            <div className="products-featured__tags">
              <span>Visible Light Imaging</span>
              <span>Embedded Processing</span>
              <span>Rugged Design</span>
            </div>

            <Link
              className="products-featured__link"
              to="/opal#opal"
            >
              Explore Opal-1920S
              <ArrowRightCircle aria-hidden="true" />
            </Link>
          </div>

          <div className="products-featured__visual">
            <div className="products-featured__ring" />

            <img
              src={opalImg}
              alt="Kristal Fotonik Opal-1920S Visible Light Camera"
              loading="lazy"
            />
          </div>
        </article>

        {/* IP CORE HEADING */}
        <div className="products-ip-heading">
          <div>
            <span>FPGA-BASED SOLUTIONS</span>
            <h3>Image Processing IP Cores</h3>
          </div>

          <p>
            Modular imaging solutions developed for integration into
            FPGA-based camera and vision systems.
          </p>
        </div>

        {/* IP CORE CARDS */}
        <div className="products-ip-grid">
          {ipCores.map((product, index) => (
            <Link
              className="product-ip-card"
              to={product.link}
              key={product.title}
              aria-label={`Explore ${product.title}`}
            >
              <div className="product-ip-card__image">
                <img
                  src={product.imgUrl}
                  alt=""
                  loading="lazy"
                />
              </div>

              <div className="product-ip-card__content">
                <div className="product-ip-card__meta">
                  <span>
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span>FPGA IP CORE</span>
                </div>

                <h4>{product.title}</h4>

                <span className="product-ip-card__action">
                  View Solution
                  <ArrowRightCircle aria-hidden="true" />
                </span>
              </div>
            </Link>
          ))}
        </div>

      </Container>
    </section>
  );
};